import { waLink, WA_GENERAL_MESSAGE } from "../data/site";

export const ContactCTA = () => {
  return (
    <section id="contatti" data-testid="contact-section" className="py-24 bg-linen text-ink">
      <div className="max-w-4xl mx-auto px-6 text-center space-y-6">
        <p className="text-xs uppercase tracking-[0.18em] text-cognac font-semibold">
          Parla direttamente con noi
        </p>
        <h2 className="font-display sec-title font-normal">Hai visto un capo che ti piace?</h2>
        <p className="text-sm max-w-md mx-auto text-ink/80 leading-relaxed">
          Inviaci una foto o chiedi info su taglia e spedizione. Ti rispondiamo
          personalmente in pochi minuti.
        </p>
        <div className="pt-4">
          <a
            href={waLink(WA_GENERAL_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-cta-whatsapp"
            className="inline-flex items-center gap-3 bg-ink text-bone px-8 py-4 rounded-full text-sm uppercase tracking-[0.14em] font-medium hover:bg-cognac transition-colors shadow-lg"
          >
            <svg className="w-5 h-5 text-emerald-400" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 13.85 2.5 15.58 3.38 17.07L2 22L7.07 20.65C8.54 21.5 10.22 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.46 16.92C16.27 17.46 15.48 17.9 15.05 17.96C14.75 18 14.37 18.03 12.98 17.46C11.21 16.73 10.07 14.93 9.98 14.81C9.89 14.69 9.27 13.86 9.27 13C9.27 12.14 9.71 11.72 9.89 11.53C10.03 11.39 10.22 11.33 10.42 11.33C10.49 11.33 10.55 11.33 10.61 11.34C10.79 11.34 10.88 11.36 11 11.65C11.15 12.01 11.51 12.9 11.55 12.99C11.59 13.08 11.63 13.19 11.57 13.31C11.51 13.43 11.46 13.49 11.37 13.59C11.28 13.69 11.18 13.81 11.1 13.9C11.01 14 10.91 14.11 11.02 14.3C11.13 14.49 11.51 15.11 12.08 15.62C12.81 16.27 13.41 16.48 13.62 16.57C13.83 16.66 13.95 16.64 14.07 16.5C14.19 16.36 14.59 15.89 14.73 15.7C14.87 15.51 15.01 15.54 15.2 15.61C15.39 15.68 16.41 16.18 16.62 16.29C16.83 16.4 16.97 16.46 17.03 16.56C17.09 16.66 17.09 17.04 16.46 16.92Z" />
            </svg>
            <span>Apri la Chat su WhatsApp</span>
          </a>
        </div>
      </div>
    </section>
  );
};
